const apiUrl = process.env.REACT_APP_API_URL;

const getAssetTypesByAreaID = (token, id, cb) => {
    fetch(`${apiUrl}/areas/${id}/assettypes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getAssetTypesByAreaID;
